var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('trailer'),_c('buy-it'),_c('about'),_c('features'),_c('pod-gallery'),_c('pod-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }